<template>
<div class="panelNagusia">
  <h1 class="ui header"><img class="ui image" src="../assets/parcels.png">
    <div class="content">Generar Envío</div>
  </h1>
  <div v-if="error" class="ui warning message"> 
    <h4 class="ui dividing header">Error</h4>
      <p v-if="msg_error"> {{ this.msg_error }} </p>
  </div>
  <div v-if="(!apmOptions) && !error" class="ui active centered inline loader"></div>
  <div v-if="apmOptions && !error" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Datos del paquete</h4>
        <form class="ui form" @submit.prevent="generateParcel">


          <div class="field">
            <label>Nombre del cliente *</label>
            <input type="text" v-model="parcelInfo.name" placeholder="Nombre del cliente" required>
          </div>

          <div class="two fields">
            <div class="field">
              <label>Teléfono del cliente * </label>
              <input type="number" id="idphone" name="phone" v-model="parcelInfo.phone" maxlength="9" placeholder="Teléfono del cliente" required oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" min="0">
            </div>
            <div class="field">
              <label>Email del cliente</label>
              <input type="email" v-model="parcelInfo.email" placeholder="Email del cliente" pattern="^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
            </div>
          </div>

          <div class="two fields">
            <div class="field">
              <label>Barcode * </label>
              <input type="text" v-model="parcelInfo.barcode" placeholder="Barcode" required>
            </div>
            <div class="field">
              <label>RefCode</label>
              <input type="text" v-model="parcelInfo.refcode" placeholder="RefCode">
            </div>
          </div>
          
          <div class="two fields">
            <div class="field">
              <label>Servicio</label>
              <sui-dropdown placeholder="Servicio" selection :options="servicesOptions" v-model="parcelInfo.service" required/>
            </div>

            <div class="field">
              <label>Hold</label>
              <input type="text" v-model="parcelInfo.hold" placeholder="Hold">
            </div>
          </div>

          <div class="field">
            <label>Cliente *</label>
            <sui-dropdown placeholder="Cliente" fluid selection :options="hapciikClientOptions" v-model="parcelInfo.key" required />
          </div>

          <div class="field">
            <label>Taquilla *</label>
            <sui-dropdown id="taquillas" search fluid :options="apmOptions" placeholder="Taquillas" selection v-model="parcelInfo.apt_id" />
          </div>

          <div class="field">
            <label>Tamaño del paquete *</label>
            <!-- <input type="text" v-model="parcelInfo.slot_size" placeholder="Tamaño del paquete"> -->
            <sui-dropdown placeholder="Tamaño del paquete" selection :options="sizesOptions" v-model="parcelInfo.slot_size" required/>
          </div> 
           <div class="field">
            <label>* Campos obligatorios</label>
          </div>
          
          <button id="generate" class="ui button fluid secondary" type="submit">Generar Envío</button>
        </form>
      </div>
      <div class="column">
        <div v-if='show' class="ui segment">
          <a class="ui red ribbon label">Envío generado</a>
          <h4>Taquilla</h4>
          <p>{{ apm_selected_gen }}</p>
          <h4>Destinatario/a</h4>
          <p>{{ name_gen }}</p>
          <h4>Teléfono</h4>
          <p>{{ phone_gen }}</p>
          <h4 v-if="email_gen">Email</h4>
          <p>{{ email_gen }}</p>
          <h4>Tamaño</h4>
          <p>{{ slotsize_gen }}</p>

          <h4 v-if="service_gen === 'B2C'"> Usa el siguiente código de barras para introducir el paquete</h4>
          <div class="field" v-if="showBarcode">
            <div class="barcodePrint" ref="downloadMe">
              <barcode v-bind:value="barcode_gen" width="2">
                Show this if the rendering fails.
              </barcode>
            </div>
          </div>
          <h4 v-if="service_gen !== 'B2C'"> Usa el siguiente código para introducir el paquete</h4>
          <h2 v-if="!showBarcode" class='no-margin-top'>{{ dropoff_code_gen }}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import VueQr from 'vue-qr';
import sizeModule from '@/components/sizeModule.vue'
import VueBarcode from 'vue-barcode';
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'GenerateAllClientParcel',
  data() {
    return {
      show: false,
      apms: null,
      admin_id: null,
      dropoff_code: null,
      showBarcode: false,
      expiresAt: null,
      apmOptions: null,
      parcelInfo: {
        place_id: null,
        apt_id: null,
        name: null,
        phone: null,
        email: null,
        slot_size: null,
        company_id: null,
        refcode: null,
        hold: null,
        barcode: null,
        barcode_alt: null,
        service: null,
        pre_table: null,
      },
      apm_selected: null,
      apm_selected_gen: null,
      name_gen: null,
      barcode_gen: null,
      phone_gen: null,
      service_gen: null,
      dropoff_code_gen: null,
      email_gen: null,
      slotsize_gen: null,
      error: false,
      msg_error: null,
      parcelSizes: [],
      hapciikClientOptions: [],
      servicesOptions: [{
          text: 'B2C',
          value: 'B2C',
        },{
          text: 'C2B',
          value: 'C2B',
        },{
          text: 'C2C',
          value: 'C2C',
        },
      ],
      sizesOptions: [{
          text: 'XS',
          value: 'XS',
        },{
          text: 'S',
          value: 'S',
        },{
          text: 'S+',
          value: 'S+',
        },{
          text: 'M',
          value: 'M',
        },{
          text: 'M+',
          value: 'M+',
        },{
          text: 'MD',
          value: 'MD',
        },{
          text: 'L',
          value: 'L',
        },{
          text: 'L+',
          value: 'L+',
        },{
          text: 'LD',
          value: 'LD',
        },{
          text: 'XL',
          value: 'XL',
        },{
          text: 'XL+',
          value: 'XL+',
        },{
          text: 'DXL',
          value: 'DXL',
        },{
          text: 'XXL',
          value: 'XXL',
        },{
          text: 'XXL+',
          value: 'XXL+',
        },{
          text: 'C',
          value: 'C',
        },
      ],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role;
    this.admin_id = JSON.parse(localStorage.admin).id;
    this.getHapiickClients()
    this.role = role;
    if (role === 'master') {
      this.getData();
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  watch: {
    'parcelInfo.key': function(new_company, old_company) {
      if (new_company !== null) {
        this.parcelInfo.company_id = this.hapciikClientOptions.find((e) => e.value == this.parcelInfo.key).company_id
        this.parcelInfo.apt_id = null;
        this.apmOptions = [];
        this.getApms(this.parcelInfo.company_id);
      }  
    },
  },
  methods: {
    getHapiickClients() {
      hapiickApi().post('/v1/clients', {
        admin_id: JSON.parse(localStorage.admin).id,
      })
      .then(request => {
        let status = request.data.status;

        if (status === 'OK') {
          this.hapiickClients = JSON.parse(JSON.stringify(request.data.data.hapiickClients))
          this.fillHapiickClientsOptions();
        } else {
          this.$swal.fire({
            type: 'error',
            title: 'Error',
            text: request.data.data.messages
          })
        }
      })
      .catch(() => console.log('error getting hapiick clients'))
    },
    fillHapiickClientsOptions() {
      for (let i = 0; i < this.hapiickClients.length; i++) {
        this.hapciikClientOptions.push({
          text: this.hapiickClients[i].HapiickClient.name,
          value: this.hapiickClients[i].HapiickClient.key,
          company_id: this.hapiickClients[i].HapiickClient.company_id,
          pre_table: this.hapiickClients[i].HapiickClient.pre_table
        })
      }
    },
    getApms(companyId) {
      hapiickApi().post('/v1/apms/companies', {
        admin_id: JSON.parse(localStorage.admin).id,
        companyId: companyId
      })
      .then(request => {
        this.apms = JSON.parse(JSON.stringify(request.data.data.apms))
        this.fillApmOptions();
      })
      .catch(() => console.log('error getting apms'))
    },
    fillApmOptions() {
      for (let i = 0; i < this.apms.length; i++) {
        this.apmOptions.push({
          key: this.apms[i].Apt.id,
          text: this.apms[i].Apt.LanguagesApts[0].name,
          value: this.apms[i].Apt.id,
          place_id: this.apms[i].Apt.place_id
        })
      }
    },
    getData() {
      hapiickApi().post('/v1/shipments/users', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then((req)  => {
        this.loadData(req.data);
      })
      .catch((req) => console.log('error getting getDataGenerateLocalParcel: ' + req))
    },
    loadData(data) {
      this.loadApmUsers(data.apms);
    },
    loadApmUsers(apms) {
      let apmsList = JSON.parse(JSON.stringify(apms));
      if (apmsList.length === 0) {
        this.error = true;
        this.msg_error = 'Imposible generar envío: no tienes máquina asignada.';
        return;
      }
      this.apmOptions = apmsList.map(apm => ({
        key: apm.place_id,
        text: apm.LanguagesApts[0].name,
        value: apm.place_id
      }));
     this.parcelInfo.place_id = this.apmOptions[0].key
    },
    generateParcel() {
      this.$swal.fire({
        title: 'Confirmar envío',
        html: '<b>Taquilla:</b>  ' + this.apm_selected  + 
              '<br /><br />' + '<b>Destinatario/a:</b>  ' + this.parcelInfo['name']  + 
              '<br /><br />' + '<b>Teléfono:</b>  ' + this.parcelInfo['phone'] + 
              '<br /><br />' + '<b>Tamaño:</b>  ' + this.parcelInfo['slot_size'] + '<br /><br />',
        type: 'question',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar'
      })
      .then((result) => {
        if (result.value) {
          this.generateLocalParcel()
          }
      })
    },
    generateLocalParcel(){
      this.show = false;

      let x = document.getElementById("generate");
      x.classList.add("loading");
      x.disabled = true;

      this.dropoff_code = null;

      this.parcelInfo.place_id = this.apmOptions.find((e) => e.key == this.parcelInfo.apt_id).place_id
      this.parcelInfo.pre_table = this.hapciikClientOptions.find((e) => e.value == this.parcelInfo.key).pre_table

      let firstDigit = 0;
      let phoneLength = 0;
      firstDigit = this.parcelInfo.phone.substr(0,1);
      phoneLength = this.parcelInfo.phone.length

      if (this.parcelInfo.company_id === null && this.parcelInfo.apt_id === null) {
        this.$swal.fire({
          type: 'info',
          text: 'Obligatorio seleccionar un cliente y una máquina',
        })
        return;
      }

      if ((firstDigit == 6 || firstDigit == 7) && phoneLength == 9 && !isNaN(this.parcelInfo.phone)) {
        hapiickApi().post('/v1/users/shipments/add', {
          admin_id: JSON.parse(localStorage.admin).id,
          parcelInfo: this.parcelInfo
        })
        .then(request => { 
          this.showResponse(request)
        })
        .catch((request) => {
          this.$swal.fire({
            type: 'error',
            text: 'Se ha producido un error al generar el envío. Prueba de nuevo.',
          })
          console.log('error generating parcel: ' + request)
          let x = document.getElementById("generate");
          x.classList.remove("loading");
          x.disabled = false;
          return;
        })
      } else {
        this.$swal.fire({
          type: 'info',
          text: 'Número de teléfono no valido. Por favor, vuelve a intentarlo.',
        })
      }
    },
    showResponse(req) {
      if ('status' in req.data || req.data.length == 0) {
        let msg_error = null;
        if (req.data.message) {
          msg_error = req.data.message
        } else {
          msg_error = 'Se ha producido un error al generar el envío. Prueba de nuevo.'
        }

        this.$swal.fire({
          type: 'error',
          text: msg_error,
        })
        let x = document.getElementById("generate");
        x.classList.remove("loading");
        x.disabled = false;
        return;
      }

      let x = document.getElementById("generate");
      x.classList.remove("loading");
      x.disabled = false;

      this.show = true;

      if (req.data.dropoff_code) {
        this.dropoff_code_gen = req.data.dropoff_code
      }

      if (req.data.barcode_alt) {
        this.barcode_gen = req.data.barcode_alt
      } else if (req.data.barcode) {
        this.barcode_gen = req.data.barcode
      }


      this.name_gen =  req.data.name;
      this.phone_gen =  req.data.phone
      this.slotsize_gen = req.data.pack_size
      this.email_gen = req.data.email
      this.apm_selected_gen = this.apmOptions.find((e) => e.place_id == req.data.place_id).text


      this.service_gen = req.data.service

      if (this.service_gen === 'B2C') {
        this.showBarcode = true;
      } else {
        this.showBarcode = false;
      }


      if (req.data.expires) {
        this.expiresAt = req.data.expires;
      }

      //vaciar campos
      this.parcelInfo.name = null
      this.parcelInfo.phone = null
      this.parcelInfo.email = null

      this.parcelInfo.barcode = null
      this.parcelInfo.service = null
      this.parcelInfo.hold = null
      this.parcelInfo.refcode = null
      this.parcelInfo.slot_size = null
      this.parcelInfo.key = null
      this.parcelInfo.apt_id = null
      if (this.expiresAt) {
        this.parcelSizes = this.parcelSizes.map((a) => {
        if (a.id == this.parcelInfo.slot_size) {
          a.empty -= 1
        }
        return a
      })
      }
      
      //QUITAR COMENTARIOS!!! Cuando se pongan las tallas, porque ahora al no estar elo div con las tallas, esta deshabilitado todo el rato el btn de generar envios al generar los envios, no se activa de nuevo.
      ///////this.defaultSelected = this.getDefaultSelected();
    },
    getDefaultSelected() {
      let default_selected = this.parcelSizes.find((a) => a.empty > 0);
      if (default_selected) {
        document.getElementById('generate').classList.remove('disabled');
      } else {
        document.getElementById('generate').classList.add('disabled');
      }
      return default_selected
    },
    goTo(where) {
      this.$router.push(where)
    }
  },
  components: {
    'qr': VueQr,
    'sizeModule': sizeModule,
    'barcode': VueBarcode
  }
}
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] { 
  -moz-appearance: textfield;
  appearance: textfield;
}

.erdian {
  border-style: solid;
  border-radius: 0.1px;
  border-color: var(--var-color);
  text-align: center;
}
.center {
  text-align: center;
}
.no-margin-top {
  margin-top: 0;
}
.no-padding {
  padding-left: 0px;
  padding-right: 0px;
}
.segment {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateAllClientParcel.vue